// src/services/branchZonesApi.js
import { axiosGet, axiosPost } from "./apiClient";

// Backend routes (admin):
//  GET    /branch/zones/:branchId
//  POST   /branch/zones/create
//  POST   /branch/zones/update
//  POST   /branch/zones/delete
//  GET    /branch/zones/logs
//  GET    /branch/zones/map/:branchId   (NEW)

const BASE_URL = process.env.REACT_APP_BASE_URL + "/branch/zones";

const getZonesByBranch = async ({
  branchId,
  limit = 10,
  page = 0,
  zoneType = null,
  activeOnly = false,
} = {}) => {
  try {
    if (!branchId) throw new Error("branchId is required");

    const response = await axiosGet(`${BASE_URL}/${branchId}`, {
      limit,
      page,
      zoneType,
      activeOnly: activeOnly ? 1 : 0,
    });
    return response;
  } catch (error) {
    console.error("Error fetching branch zones:", error);
    throw error;
  }
};

const createZone = async (params = {}) => {
  try {
    const response = await axiosPost(`${BASE_URL}/create`, { ...params });
    return response;
  } catch (error) {
    console.error("Error creating branch zone:", error);
    throw error;
  }
};

const updateZone = async (params = {}) => {
  try {
    const response = await axiosPost(`${BASE_URL}/update`, { ...params });
    return response;
  } catch (error) {
    console.error("Error updating branch zone:", error);
    throw error;
  }
};

const deleteZone = async (params = {}) => {
  try {
    const response = await axiosPost(`${BASE_URL}/delete`, { ...params });
    return response;
  } catch (error) {
    console.error("Error deleting branch zone:", error);
    throw error;
  }
};

const getZoneLogs = async ({
  zoneId = null,
  branchId = null,
  page = 1,
  pageSize = 10,
} = {}) => {
  try {
    const response = await axiosGet(`${BASE_URL}/logs`, {
      zoneId,
      branchId,
      page,
      pageSize,
    });
    return response;
  } catch (error) {
    console.error("Error fetching branch zone logs:", error);
    throw error;
  }
};

/**
 * NEW: fetch zones for map overlay.
 * Returns other branches zones (and optionally selected branch zones)
 *
 * Backend: GET /branch/zones/map/:branchId?zoneType=PRIMARY&activeOnly=1&includeSelf=0
 */
const getZonesForMap = async ({
  branchId,
  zoneType = "PRIMARY",
  activeOnly = true,
  includeSelf = false,
} = {}) => {
  try {
    if (!branchId) throw new Error("branchId is required");

    const response = await axiosGet(`${BASE_URL}/map/${branchId}`, {
      zoneType,
      activeOnly: activeOnly ? 1 : 0,
      includeSelf: includeSelf ? 1 : 0,
    });

    return response;
  } catch (error) {
    console.error("Error fetching zones for map:", error);
    throw error;
  }
};

const branchZonesApi = {
  getZonesByBranch,
  createZone,
  updateZone,
  deleteZone,
  getZoneLogs,
  getZonesForMap,
};

export default branchZonesApi;
